import React from 'react';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/library/src/CategoryHeading';
import { List } from '@fuww/library/src/List';
import withQuery from '../../../lib/withQuery';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.mjs';
import NewsFeedListItem from '../../News/Article/NewsFeedListItem';
import articlesConnectionQuery
  from '../../../lib/queries/news/articlesConnectionQuery.graphql';
import getConnectionField, {
  ConnectionField,
} from '../../../lib/queries/getConnectionField';
import getNewsboardFieldVariables
  from '../../../lib/queries/getNewsboardFieldVariables';
import {
  newsFeedImageConfigurations,
} from '../../../lib/imageConfigurations';
import { minimumPositiveValue } from '../../../lib/isPositiveSentiment';
import {
  ArticlesConnectionQuery,
  ArticlesConnectionQueryVariables,
  NewsArticleConnection,
  NewsArticleEdge,
} from '../../../lib/graphql/api/graphql';

const RelatedNews = withQuery(({
  data, field, variables,
}: {
  data: ArticlesConnectionQuery;
  field: ConnectionField;
  variables: ArticlesConnectionQueryVariables;
}) => {
  const { edges } = data[field] as NewsArticleConnection;

  return (
    <List>
      {edges.map((edge: NewsArticleEdge, index: number) => {
        const { node } = { ...edge };

        return (
          <NewsFeedListItem
            article={node}
            isPressRelease={node.pressRelease}
            isPartnerContent={node.partnerContent}
            variables={variables}
            isFirstImage={index === 0}
            key={node.id.toString()}
          />
        );
      })}
    </List>
  );
});

const RelatedNewsWithQuery = ({
  tagSlugs,
}: {
  tagSlugs: string[];
}) => {
  const intl = useIntl();
  const {
    hasLocalNews,
    newsboard,
    prefix,
  } = useSiteContext();

  const articlesField = getConnectionField(prefix, hasLocalNews);
  const variables = {
    ...getNewsboardFieldVariables(prefix, hasLocalNews),
    pageviews: false,
    sort: 'CREATED_AT',
    newsboards: [newsboard],
    first: 3,
    imageConfigurations: newsFeedImageConfigurations,
    tagSlugs,
    minScores: {
      name: 'positive',
      value: minimumPositiveValue,
    },
  };

  return (
    <>
      <CategoryHeading>
        {intl.formatMessage(messages.relatedNews)}
      </CategoryHeading>
      <RelatedNews
        query={articlesConnectionQuery}
        variables={variables}
        errorMessage="Error loading related news"
        field={articlesField}
      />
    </>
  );
};

export default RelatedNewsWithQuery;
